module.exports = __webpack_public_path__ + "assets/quill.752a6b47.svg";